module.exports = __webpack_public_path__ + "media/images/v2/hassle_free-c4f9cbd533f379853f308e0a7b8a0a8a.png";